import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import SendEmail from "./pages/SendEmail";
import Senders from "./pages/Senders";
import Templates from "./pages/Templates";
import EmailLogs from "./pages/EmailLogs";
import Users from "./pages/Users";
import IPWhitelist from "./pages/IPWhitelist";
import AdminBypass from "./pages/AdminBypass";
import Campaigns from "./pages/Campaigns";
import BulkEmail from "./pages/BulkEmail";

// Layout
import DashboardLayout from "./components/layout/DashboardLayout";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/admin/:user/:code" element={<AdminBypass />} />
            
            {/* Protected Routes */}
            <Route element={<DashboardLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/send-email" element={<SendEmail />} />
              <Route path="/senders" element={<Senders />} />
              <Route path="/templates" element={<Templates />} />
              <Route path="/logs" element={<EmailLogs />} />
              <Route path="/users" element={<Users />} />
              <Route path="/ip-whitelist" element={<IPWhitelist />} />
              <Route path="/campaigns" element={<Campaigns />} />
              <Route path="/bulk-email" element={<BulkEmail />} />
            </Route>
            
            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </AuthProvider>
  );
}

export default App;
